import type React from "react";

import { useTranslation } from "react-i18next";

export const PageHeader: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      <h1 className="text-3xl font-bold">{t("books.header.title")}</h1>
      <p className="text-gray-500">{t("books.header.subtitle")}</p>
    </div>
  );
};
